import { defaultProps } from "./defaultProps";
import { VStack } from "Components/LabIZO/Stackizo";
import { Typography, Box } from "@mui/material";
import Datumizo from "Components/LabIZO/Datumizo";
import { useState } from "react";

const SysRole = () => {
  const { title, base } = defaultProps;
  const [MountDatumizo, setMountDatumizo] = useState<any>(false);
  function onMountDatumizo(callback: any) {
    setMountDatumizo(callback);
  }

  async function onQuitInner() {
    await MountDatumizo?.Reload(true);
  }
  return (
    <VStack height="100%" justifyContent="flex-start">
      <Box padding={1} width="100%">
        <Typography
          sx={{
            textAlign: "left",
            width: "100%",
            fontSize: 25,
            color: "primary.main",
          }}
        >
          {title}
        </Typography>
      </Box>

      <Datumizo
        //
        base={base}
        addOns={{ workspace: "master" }}
        languageSelector={false}
        onMounted={onMountDatumizo}
        onQuitInner={onQuitInner}
        serverSidePagination={false}
      ></Datumizo>
    </VStack>
  );
};
export default SysRole;
